export default {
  DriverManagementTitle: 'Driver Management',
  buttonNewInterface: 'New Interface',
  InterfaceCD: 'Interface CD',
  InterfaceName: 'Interface Name',
  InterfaceType: 'Transport Type',
  category: 'Category',
  protocol: 'Protocol',
  connectionMode: 'Connection Mode',
  ipAddress: 'IP Address',
  ipPort: 'IP Port',
  confirmDeleteDriver: 'Confirm delete Driver?',
  deleteSuccess: 'Driver deleted successfully',
  buttonEditDriver: 'Edit Interface',
  saveSuccess: 'Driver saved successfully',
}
